import { render, staticRenderFns } from "./PageEditScoreDescription.vue?vue&type=template&id=165d3b4c&"
import script from "./PageEditScoreDescription.vue?vue&type=script&lang=js&"
export * from "./PageEditScoreDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports